import React, { FC, ReactElement } from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';

import { IdeaUpdateFormValues } from '@buyside/components/presentation/IdeaShowPage/AuthorActions/ideaUpdateForm';
import Icon from '@buyside/components/presentation/Icon/icon';

import { impactOptions, ImpactValues } from '@buyside/util/ideaUpdateFormHelper';

import styles from '../authorActionsStyles.scss';

const IdeaUpdateImpact: FC = () => {
  const {
    watch,
    register,
    formState: { errors }
  } = useFormContext<IdeaUpdateFormValues>();

  const impact = watch('impact');

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionHeader}>
        <strong>How does this update impact your original position?</strong>
      </div>
      <div className={styles.impactContainer}>
        {impactOptions.map(
          (option): ReactElement => {
            const { icon, label, value } = option;
            return (
              <div key={value} className={styles.buttonWrapper}>
                <label
                  className={classNames(styles.impactButton, {
                    [styles.selected]: value === impact
                  })}
                >
                  <Icon
                    type={icon}
                    className={classNames(styles.impactIcon, {
                      [styles.green]: value === ImpactValues.POSITIVE,
                      [styles.red]: value === ImpactValues.NEGATIVE
                    })}
                  />
                  <input aria-label="impact" type="radio" {...register('impact')} value={value} />
                  {label}
                </label>
              </div>
            );
          }
        )}
      </div>
      {errors.impact && (
        <div className={classNames(styles.errorText, styles.impactError)}>
          {errors.impact.message}
        </div>
      )}
      <div className={styles.bottomText}>
        <strong>Note:</strong> For updates expected to improve the performance of short ideas,
        select "Positively".
      </div>
    </div>
  );
};

export default IdeaUpdateImpact;
